import { defineMessages } from 'react-intl';

export default defineMessages({
    householdDriverx: {
        id: 'ml.quoteandbind.pup.additionalInformation.householdDriverx',
        defaultMessage: 'Household Member {householdMemberNumber}'
    },
    pupHouseholdDriverOccupation: {
        id: 'ml.quoteandbind.pup.additionalInformation.householdDriver.Occupation',
        defaultMessage: 'Occupation'
    },
    occupationHelpTextTitle: {
        id: 'ml.quoteandbind.pup.additionalInformation.householdDriver.Why do you need my occupation?',
        defaultMessage: 'Why do you need my occupation?'
    },
    occupationHelpText: {
        id: 'ml.quoteandbind.pup.additionalInformation.householdDriver.occupationHelpText',
        defaultMessage: 'Where permissible by law, your occupation is one of the factors used in determining your rate, as well as, your eligibility for discounts.'
    },
    addtlInterestPound: {
        id: 'ml.quoteandbind.pup.additionalInformation.householdDriver.pound',
        defaultMessage: '#'
    },
    ageFirstLicensed: {
        id: 'ml.quoteandbind.pup.additionalInformation.householdDriver.Age First Licensed',
        defaultMessage: 'Age First Licensed'
    }
});
